<template>
    <div
        class="mobile-layout"
        :class="{
            'is-from-crm-applet': isFromCrmApplet(),
            'is-use-tabbar': isUseTabbar(),
        }"
    >
        <NavBar />
        <!-- Todo：Banner 暂不显示、目前使用的是 PC 端的图片、存在一些问题 -->
        <!-- <Banner /> -->
        <div class="mobile-layout__content">
            <transition name="el-fade-in-linear" mode="out-in">
                <router-view />
            </transition>
        </div>
        <Footer />
        <!-- 悬浮按钮 -->
        <Capsule />
    </div>
</template>

<script>
import { isFromCrmApplet, isUseTabbar } from '@/utils/formAppInfo.js'
import NavBar from './components/NavBar.vue'
import Banner from './components/Banner.vue'
import Footer from './components/Footer.vue'
import Capsule from './components/Capsule.vue'

export default {
    name: 'MobileLayout',
    components: {
        NavBar,
        Banner,
        Footer,
        Capsule,
    },
    methods: {
        isFromCrmApplet,
        isUseTabbar,
        smoothScrollToTop() {
            const timer = setTimeout(() => {
                clearTimeout(timer)
                window?.scrollTo && window.scrollTo({ top: 0, behavior: 'smooth' })
            }, 800)
        },
    },
    // beforeRouteUpdate(_to, _from, next) {
    //     this.smoothScrollToTop()
    //     next()
    // },
}
</script>

<style lang="less">
.mobile-layout {
    width: 100vw;
    min-height: 100vh;
    padding-top: 1.2rem;
    font-size: 0.28rem;
    overflow-y: hidden;

    * {
        box-sizing: border-box;
    }

    img {
        vertical-align: middle;
    }

    /* 接入微甄房小程序：设置兼容样式 */
    &.is-from-crm-applet {
        padding-top: 0.92rem;

        .mobile-nav-bar {
            height: 0.92rem;
            border-top: 1px solid #ececec;

            &__menu {
                top: calc(0.92rem - 1px);
            }

            &__mask {
                top: calc(0.92rem + 1px);
            }

            &__trigger {
                transform: scale(0.75);
            }
        }
    }

    /* 接入微甄房小程序：兼容 tabbar 样式 */
    &.is-use-tabbar {
        .mobile-footer {
            padding-bottom: 1.8rem;
        }

        .mobile-capsule {
            bottom: 3.22rem;
        }
    }
}
</style>
